<template>
    <div class="body">
        <el-form ref="form" class="form" :model="form" label-width="80px">
            <p>公共设施</p>
            <template>
                 <el-checkbox-group   v-model="checkedCities" :min="1" :max="20">
                     <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
                 </el-checkbox-group>
            </template>
        </el-form>
    </div>    
</template>

<script>
  const cityOptions = ['收费停车场', '免费停车场', '无停车场', '有餐厅', '无餐厅', '有电梯', '无电梯', '健身房', '会议室', '吸烟区', '大堂吧', '储物柜', '室内游泳池', '室外游泳池', '公共休息室', '自动取款机', '前台贵重物品保险柜'];
  export default {
    data() {
      return {
        checkedCities: ['收费停车场'],
        cities: cityOptions
      };
    },
    methods:{
        
    }
  };
</script>

<style scoped>

.form{
    padding-top: 1%;
    padding-bottom: 1%;
}

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/setup/hotelService.vue